import React, { useEffect, useState, useCallback, useMemo } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";

import Input from "antd/es/input/Input";
import DeleteConfirmationModal from "../../../../src/components/Modal/DeleteConfirmation";
import LookupReceiptSaleModal from "../../../components/Modal/LookupReceiptSaleModal";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import Select from "react-select";
import { Dash1, Dash2, Dash3, Dash4 } from "../../../common/imagePath";
import CountUp from "react-countup";
import moment from "moment";
import * as XLSX from "xlsx";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";

import { checkUserPermission } from "../../../common/UserPermission";
import { Box, Button, MenuItem } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import DeliveryStatusConfirmation from "../../../components/Modal/DeliveryStatusConfirmation";
import {
  generateFinalKey,
  handleSaveColumnOrder,
} from "../../../common/common";
import CommonMatrialReactTableServerSideRender from "../../../components/Datatable/CommonMatrialReactTableServerSideRender";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import CommonDatePicker from "../../../components/DatePicker/CommonDatePicker";

const Sales = (props) => {
  const locationData = useLocation();
  console.log(locationData?.state?.status, "checking");
  let selectData = [];
  let PERMISSION_DELETE = "sales-batch-delete";
  let PERMISSION_EDIT = "/manage-sales/:id";
  let PERMISSION_ADD = "/manage-sales";
  let PERMISSION_RECEIVEPAYMENT = "/receive-payment";
  let PERMISSION_RECEIPT = "/sales-receipt/:id";
  let PERMISSION_CUSTOMER_CUSTOM_INVOICE = "";
  let PERMISSION_LOOKUPRECEIPT = "/sales-receipt";
  let PERMISSION_DELIVERIES = "/deliveries";
  let PERMISSION_BATCHSALES = "/batch-sales";
  let PERMISSION_CUSTOMFIELD = "/custom-field-sales-configuration";
  let PERMISSION_ALLRECEIPT = "/sales-all-receipt";
  let PERMISSION_DRIVERREPORT = "/Driver-Daily-sheet";

  const navigate = useNavigate();
  const token = localStorage.getItem("Token");
  const location = localStorage.getItem("Location");
  const loginuserid = localStorage.getItem("ID");

  const [perPageSize, setperPageSize] = useState(25);
  const [totalRows, setTotalRows] = useState(0);
  const [salePaymentStatus, setSalePaymentStatus] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  // const [selectedData, setSelectedData] = useState([]);
  const [sortingId, setSortingId] = useState(1);
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [quickbookarray, setquickbookarray] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [data, setData] = useState([]);
  const [selectedSalesCheckboxIds, setselectedSalesCheckboxIds] = useState("");
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [saletype, setSaletype] = useState([]);
  const [custoptions, setCustOptions] = useState([]);
  const [salesSummary, setSalesSummary] = useState([]);
  const [status, setStatus] = useState(0);
  const [isShowEcomOrders, setIsShowEcomOrders] = useState(1);
  // const [closeMenuofrow, setCloseMenuofrow] = useState(null);

  const onBtExport = (filterData, field) => {
    const workbook = XLSX.utils.book_new();

    let Data = [];

    if (field === "AllData") {
      Data = data;
    } else {
      Data = filterData?.map((el) => el?.original);
    }

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(Data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `Exel_File.xlsx`);
  };

  const options = [
    { label: "All", value: 1 },
    { label: "Current Week", value: 4 },
    { label: "Last Week", value: 3 },
    { label: "Current Month", value: 6 },
    { label: "Last Month", value: 5 },
    { label: "Custom", value: 2 },
    { label: "Last 7 Day", value: 7 },
  ];

  const ishowEcomOptions = [
    { label: "All", value: 1 },
    { label: "Portal Order", value: 2 },
    { label: "Ecom Order", value: 3 },
  ];

  const [quickBookOptions, setQuickBookOptions] = useState({
    label: "Last 7 Day",
    value: 7,
  });

  console.log(quickBookOptions, "isShowEcomOrders");

  const [startingDate, setStartingDate] = useState("");
  const [endingDate, setEndingDate] = useState("");

  const [customStartingDate, setCustomStartingDate] = useState(moment().format('MM-DD-YYYY'));
  const [customEndingDate, setCustomEndingDate] = useState(moment().format('MM-DD-YYYY'));

  const [salesTypeID, setSalesTypeID] = useState(0);
  const [customerID, setCustomerID] = useState(0);
  const [salesTypeValue, setSalesTypeValue] = useState();
  const [customerValue, setCustomerValue] = useState();

  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  //table state
  const [columnVisibility, setColumnVisibility] = useState({});
  const [columnOrder, setColumnOrder] = useState([]);
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const [deliveryStatusList, setDeliveryStatusList] = useState([]);
  const [showDeliverySelect, setShowDeliverySelect] = useState({
    id: 0,
    DeliveryStatusID: -1,
  });
  const [deliveryModalOpen, setDeliveryModalOpen] = useState(false);

  console.log(showDeliverySelect, "showDeliverySelect");
  console.log(deliveryStatusList, "deliveryStatusList");
  // Styles
  // const selectStyles = {
  //   // dropdown input css
  //   control: (provided, state) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //     border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
  //     "&:hover": {
  //       border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     },
  //   }),
  //   // dropdown menu css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
  //     position: "absolute",
  //     "z-index": "999",
  //     background: "#f8f8f8",
  //     width: "100%",
  //   }),
  //   // dropdown option css
  //   option: (provided, state) => ({
  //     ...provided,
  //     backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
  //     "&:hover": {
  //       backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
  //     },
  //   }),
  // };
  // const selectStyles = {
  //   // dropdown input css
  //   control: (provided, state) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //     border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
  //     "&:hover": {
  //       border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     },
  //   }),
  //   // dropdown menu css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
  //     position: "absolute",
  //     "z-index": "999",
  //     background: "#f8f8f8",
  //     color: "#000",
  //     width: "100%",
  //   }),
  //   // dropdown option css
  //   option: (provided, state) => ({
  //     ...provided,
  //     color: state.isActive ? "#000" : "#000",
  //     backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
  //     "&:hover": {
  //       color: "#000",
  //       backgroundColor: "rgba(255, 159, 67, 0.8)", // change hover color to light orange
  //     },
  //   }),
  // };

  // const handleChangeCustomStartingDate = (event) => {
  //   console.log("event starting ==> ", event.target.value);
  //   setCustomStartingDate(event.target.value);
  //   setStartingDate(event.target.value);
  // };

  const handleChangeCustomStartingDate = (selectedDate) => {
    if (selectedDate && selectedDate.length > 0) {
      // const datetime =
      //   moment(selectedDate[0]).format("YYYY-MM-DDT00:00:00.000") + "Z";
      // const settime = moment(datetime).format("YYYY-MM-DD");
      // console.log(settime, "settime");
      setCustomStartingDate(selectedDate);
      setStartingDate(selectedDate);
    }
  };


  // const handleChangeCustomEndingDate = (event) => {
  //   // console.log("event ending ==> ", event.target.value);
  //   setCustomEndingDate(event.target.value);
  //   setEndingDate(event.target.value);
  // };


  const handleChangeCustomEndingDate = (selectedDate) => {
    if (selectedDate && selectedDate.length > 0) {
      // const datetime =
      //   moment(selectedDate[0]).format("YYYY-MM-DDT00:00:00.000") + "Z";
      // const settime = moment(datetime).format("YYYY-MM-DD");
      // console.log(settime, "settime");
      setCustomEndingDate(selectedDate);
      setEndingDate(selectedDate);
    }
  };
  console.log("QuickBookOptions::>>", quickBookOptions);
  const handleQuickBookChange = (event) => {
    setQuickBookOptions(event);

    // for  custom date
    if (event?.value == 2) {
     return;
    }

    // All Condition
    if (event?.value == 1) {
      const startYearDate = moment().startOf("year").format("YYYY-MM-DD");
      const endYearDate = moment().endOf("year").format("YYYY-MM-DD")
      setStartingDate(startYearDate);
      setEndingDate(endYearDate);
    }
    // Custom Condition
    else if (event?.value == 2) {
      setStartingDate(customStartingDate);
      setEndingDate(customEndingDate);
    }
    // Last Week Condition
    else if (event?.value == 3) {
      const lastWeekStartDate = moment()
        .subtract(1, "week")
        .startOf("week")
        .format("YYYY-MM-DD");
      const lastWeekEndDate = moment()
        .subtract(1, "week")
        .endOf("week")
        .format("YYYY-MM-DD");

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Current Week Condition
    else if (event?.value == 4) {
      const lastWeekStartDate = moment().startOf("week").format("YYYY-MM-DD");
      const lastWeekEndDate = moment().endOf("week").format("YYYY-MM-DD");
      console.log(
        "lastWeekStartDate: " + lastWeekStartDate,
        "| " + "lastWeekEndDate" + lastWeekEndDate
      );

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Last Month Condition
    else if (event?.value == 5) {
      const lastMonthStartDate = moment()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      const lastMonthEndDate = moment()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD");

      setStartingDate(lastMonthStartDate);
      setEndingDate(lastMonthEndDate);
    }
    // Current Month Condition
    else if (event?.value == 6) {
      const firstdate = moment().startOf("month").format("YYYY-MM-DD");
      const lastdate = moment().endOf("month").format("YYYY-MM-DD");

      setStartingDate(firstdate);
      setEndingDate(lastdate);
    }
    // Current Month Condition
    else if (event?.value == 7) {
      const startLast7DayDate = moment().subtract(6, 'days').startOf('day').format('YYYY-MM-DD');
      const endLast7DayDate = moment().endOf('day').format('YYYY-MM-DD');
      setStartingDate(startLast7DayDate);
      setEndingDate(endLast7DayDate);
    } else {
      const startYearDate = moment().startOf("year").format("YYYY-MM-DD");
      const endYearDate = moment().endOf("year").format("YYYY-MM-DD")
      setStartingDate(startYearDate);
      setEndingDate(endYearDate);
    }
  };

  //   useEffect(() =>{
  //     if(locationData?.state?.status){
  //       setStatus(locationData?.state?.status)
  //     }
  //   },
  // []);

  // useEffect(() =>{
  //   if(locationData?.state?.type){
  //     setSalesTypeID(locationData?.state?.type)
  //   }
  // },
  // []);

  useEffect(() => {
    console.log(localStorage.getItem("DashboardTypeFilter"), "testuuu 1");
    if (localStorage.getItem("DashboardTypeFilter")) {
      console.log(localStorage.getItem("DashboardTypeFilter"), "testuuu 2");
      setStatus(localStorage.getItem("DashboardTypeFilter"));
    }

    if (localStorage.getItem("DashboardTypeFilterstatus")) {
      console.log(
        localStorage.getItem("DashboardTypeFilterstatus"),
        "testuuu 2"
      );
      setStatus(localStorage.getItem("DashboardTypeFilterstatus"));
    }

    console.log(localStorage.getItem("DashboardTypeFiltertype"), "testuuu 1");
    if (localStorage.getItem("DashboardTypeFiltertype")) {
      console.log(localStorage.getItem("DashboardTypeFiltertype"), "testuuu 2");
      setSalesTypeID(localStorage.getItem("DashboardTypeFiltertype"));
    }

    if (localStorage.getItem("DashboardTypeFiltersalePaymentStatus")) {
      console.log(
        localStorage.getItem("DashboardTypeFiltersalePaymentStatus"),
        "testuuu 2"
      );
      setSalePaymentStatus(
        localStorage.getItem("DashboardTypeFiltersalePaymentStatus")
      );
    }
  }, []);

  useEffect(() => {
    if (quickBookOptions?.value == 1) {
      const startYearDate = moment().startOf("year").format("YYYY-MM-DD");
      const endYearDate = moment().endOf("year").format("YYYY-MM-DD")
      setStartingDate(startYearDate);
      setEndingDate(endYearDate);
    }

    // Custom Condition
    // else if (quickBookOptions?.value == 2) {
    //   setStartingDate(customStartingDate);
    //   setEndingDate(customEndingDate);
    // }
    // Last Week Condition
    else if (quickBookOptions?.value == 3) {
      const lastWeekStartDate = moment()
        .subtract(1, "week")
        .startOf("week")
        .format("YYYY-MM-DD");
      const lastWeekEndDate = moment()
        .subtract(1, "week")
        .endOf("week")
        .format("YYYY-MM-DD");

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Current Week Condition
    else if (quickBookOptions?.value == 4) {
      const currentWeekStartDate = moment()
        .startOf("week")
        .format("YYYY-MM-DD");
      const currentWeekEndDate = moment().endOf("week").format("YYYY-MM-DD");

      setStartingDate(currentWeekStartDate);
      setEndingDate(currentWeekEndDate);
    }
    // Last Month Condition
    else if (quickBookOptions?.value == 5) {
      const lastMonthStartDate = moment()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      const lastMonthEndDate = moment()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD");

      setStartingDate(lastMonthStartDate);
      setEndingDate(lastMonthEndDate);
    }
    //currentmonth
    else if (quickBookOptions?.value == 6) {
      const currentFirstDate = moment().startOf("month").format("YYYY-MM-DD");
      const currentLastDate = moment().endOf("month").format("YYYY-MM-DD");

      setStartingDate(currentFirstDate);
      setEndingDate(currentLastDate);
    }
    //last 7 day
    else if (quickBookOptions?.value == 7) {
      const startLast7DayDate = moment().subtract(6, 'days').startOf('day').format('YYYY-MM-DD');
      const endLast7DayDate = moment().endOf('day').format('YYYY-MM-DD');
      setStartingDate(startLast7DayDate);
      setEndingDate(endLast7DayDate);
    } else {
      const today = moment().format("YYYY-MM-DD");
      setStartingDate(today);
      setEndingDate(today);
      setCustomEndingDate(today);
    }
  }, [quickBookOptions]);

  const handleSearchAccordingToDate = () => {
    handleListData(
      startingDate,
      endingDate,
      salesTypeID,
      customerID,
      globalFilter,
      pagination,
      sorting,
      status,
      columnFilters,
      isShowEcomOrders
    );
  };

  const handleUnSuspend = (pID) => {
    axios
      .get(
        `${config.salesconfigBaseUrl}/sales/findbyid?id=${pID}`,

        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // console.log("res from Suspended Receiving", res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleRowSelected = (e) => {
    if (e.selectedRows.length > 0) {
      setSelectedRows(e.selectedRows.map((x) => x.ID));
      selectData[currentPage] = e.selectedRows.map((x) => x.ID);
      console.log(e.selectedRows.map((x) => x.ID));

      const selectedSalesCheckboxIds =
        selectData.length > 0 ? selectData[currentPage].toString() : "";
      setselectedSalesCheckboxIds(selectedSalesCheckboxIds);
      console.log(selectedSalesCheckboxIds);
    }
  };

  useEffect(() => {
    axios
      .get(`${config.salesconfigBaseUrl}/sales/deliverystatuslist`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        //console.log(res.data.ResponseData);

        const listData = res.data?.ResponseData?.map((el) => {
          return {
            label: el.Name,
            value: el.ID,
          };
        });
        setDeliveryStatusList(listData);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  // Get all tag data
  const handleListData = (
    // pagenumber,
    // pagesize,
    // filtertext,
    // ordercolumn,
    // currentorder,
    startingdate,
    endingdate,
    salestypeid,
    customerid,
    globalFilter,
    pagination,
    sorting,
    status,
    columnFilters,
    isShowEcomOrders
  ) => {
    setLoading(true);

    salestypeid = salestypeid > 0 ? salestypeid : 0;
    customerid = customerid > 0 ? customerid : 0;
    startingdate = startingdate === undefined ? "" : startingdate;
    endingdate = endingdate === undefined ? "" : endingdate;

    const FilterColumnText = {};
    // FilterColumnText.filtercolumntext = columnFilters;
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return { columnname: el.id, value: el.value, id: index + 1 };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    // const columnIndex = columns.findIndex(
    //   (column) => column.accessorKey === sorting[0]?.id
    // );

    const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";
    
    console.log(quickBookOptions, startingdate,endingdate, "check sales date")

    if(quickBookOptions?.value !== 1 && startingdate === "" && endingdate === ""){
      setLoading(false);
      return
    }

    console.log(startingDate , "12366666")

    axios
      .get(
        `${
          config.salesconfigBaseUrl
        }/sales/saleslist?filtercolumnsearchtext=${FilterColumnSearchText}&pagenumber=${
          pagination.pageIndex + 1
        }&pagesize=${pagination.pageSize}&filtertext=${
          globalFilter == undefined ? "" : globalFilter
        }&ordercolumn=${columnIndex}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&startdate=${startingdate}&status=${status}&enddate=${endingdate}&salestypeid=${salestypeid}&customerid=${customerid}&LocationID=${localStorage.getItem(
          "Location"
        )}&isShowEcomOrders=${isShowEcomOrders}&SalePaymentStatus=${salePaymentStatus}&loginId=${loginuserid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res.data.ResponseData?.list);
        setData(res.data.ResponseData?.list);
        setTotalRows(res.data.ResponseData?.list[0]?.TotalRecord);
        setRowCount(res.data.ResponseData?.list[0]?.TotalRecord);

        setColumnOrder(res.data.ResponseData?.ColumnOrder.split(","));

        const keysToSetFalse = res.data.ResponseData?.ColumnsHide || "";

        // Create default object with all values set to true
        const obj = columns.reduce((acc, item) => {
          acc[item.accessorKey] = true;
          return acc;
        }, {});

        // Comma-separated string of keys to set to false

        // Convert the string to an array and set the corresponding keys in the object to false
        keysToSetFalse.split(",").forEach((key) => {
          if (obj.hasOwnProperty(key)) {
            obj[key] = false;
          }
        });

        setColumnVisibility(obj);

        setLoading(false);
        localStorage.removeItem("DashboardTypeFilterstatus");
        localStorage.removeItem("DashboardTypeFiltertype");
        localStorage.removeItem("DashboardTypeFiltersalePaymentStatus");
        localStorage.removeItem("DashboardTypeFilter");
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  // const handleDeletePopup = (pID) => {
  //   const deleteRequestParam = {
  //     saleids: pID || selectedSalesCheckboxIds,
  //     locationid: location,
  //     loginuserid: loginuserid,
  //   };
  //   localStorage.setItem(
  //     "DeleteRequestParam",
  //     JSON.stringify(deleteRequestParam)
  //   );
  // };

  const handleDeletePopup = (saletypeid, id, qbid, rows, field) => {
    console.log(id, "id=====>");
    let ids;
    let rowdata = [];

    if (field == "multipleRowInactive") {
      console.log("checkes");
      ids = rows.map((el) => el.original.ID).join(",");
      rowdata = rows.map((el) => {
        return {
          quickbookid: el.original.QuickBookId,
          type: el.original.SaleTypeId,
        };
      });
      // setquickbookarray(rowdata);
      console.log(rowdata, "rowdata====>");
    } else {
      ids = id;
      const obj = {
        quickbookid: qbid,
        type: saletypeid,
      };
      rowdata.push(obj);
    }

    const deleteRequestParam = {
      quickbookarray: rowdata,
      saleids: ids,
      locationid: location,
      loginuserid: loginuserid,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    // setShowDateFilterModal(true);
    // setShowAction(false);
    setDeleteModalOpen(true);
  };

  const handleDeliveryPopup = (SaleID, closeMenu) => {
    console.log(SaleID, "id=====>");

    setShowDeliverySelect((prev) => {
      return {
        ...prev,
        id: SaleID,
      };
    });
    // setCloseMenuofrow(closeMenu);
    closeMenu();

    setDeliveryModalOpen(true);
  };
  useEffect(() => {
    // if (quickBookOptions?.value !== 2) {
    handleListData(
      // 1,
      // perPageSize,
      // searchtext,
      // sortingId,
      // sortingDirection,
      startingDate,
      endingDate,
      salesTypeID,
      customerID,
      globalFilter,
      pagination,
      sorting,
      status,
      columnFilters,
      isShowEcomOrders
    );
    // }
  }, [
    salesTypeID,
    customerID,
    status,
    // quickBookOptions,
    startingDate,
      endingDate,
    globalFilter,
    pagination,
    sorting,
    columnFilters,
    isShowEcomOrders,
  ]);

  const statusoption = [
    { label: "All", value: 0 },
    { label: "Completed", value: 2 },
    { label: "Paid", value: 4 },
    { label: "Pending", value: 1 },
    { label: "Void", value: 3 },
  ];

  const contextActions = useMemo(() => {
    const handleDeletePopup = (pID) => {
      const deleteRequestParam = {
        saleids: selectedSalesCheckboxIds,
      };
      localStorage.setItem(
        "DeleteRequestParam",
        JSON.stringify(deleteRequestParam)
      );
    };

    return (
      <button
        type="button"
        className="btn btn-danger btn-sm pull-left "
        data-bs-toggle="modal"
        data-bs-target="#DeleteConfirmationModal"
        onClick={handleDeletePopup}
      >
        <i className="fa fa-trash fa-sm" /> Delete
      </button>
    );
  }, [data, selectedRows, toggleCleared]);

  // const formatDate = (string) => {
  //   var options = { year: "numeric", month: "long", day: "numeric" };
  //   return new Date(string).toLocaleDateString([], options);
  // };

  const formatDate = (string) => {
    return moment(string).format("YYYY-DD-MM");
  };

  // onfleet Poat aip for sync

  // const OnfliteData = (row) => {
  //   setLoading(true);
  //   axios
  //     .post(
  //       `${config.salesconfigBaseUrl}/sales/saleonfleetID`,
  //       {
  //         id: row.original.ID,
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           "Access-Control-Allow-Origin": "*",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //     });

  //   // window.location.reload();
  //   handleListData(
  //     // 1,
  //     // perPageSize,
  //     // searchtext,
  //     // sortingId,
  //     // sortingDirection,
  //     startingDate,
  //     endingDate,
  //     salesTypeID,
  //     customerID,
  //     globalFilter,
  //     pagination,
  //     sorting,
  //     status,
  //     columnFilters,
  //     isShowEcomOrders
  //   );
  // };

  const columns = useMemo(() => [
    // {
    //   header: "OnFleet",
    //   size: 110,
    //   Cell: ({ row }) =>
    //     row.original.onfleet > 0 ? (
    //       <div>
    //         <Box
    //           // class="text-warning word-break-data"
    //           // to={`/manage-suppliers/${row.original.SupplierId}`}
    //           component="span"
    //           sx={(theme) => ({
    //             backgroundColor: "var(--ONFLEET-SYNC-button-color)",
    //             borderRadius: "0.3rem",
    //             color: "var(--primary-base-color)",
    //             maxWidth: "25ch",
    //             p: "0.5rem",
    //             cursor: "pointer",
    //             display: "flex",
    //             alignItems: "center",
    //             gap: "6px",
    //           })}
    //           onClick={() => {
    //             console.log(row.original.ID, "sjdcnsdnvj");
    //             OnfliteData(row);
    //           }}
    //         >
    //           <img
    //             src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACM0lEQVR4AWIAgfXt3xVWN35ZsKrxy3Mg/XtVI4C9amAOHgqC/eufbdusbdu2bcbcdptJU+Sldm8mTm537+5tJBzHxtyx1+UJYhFzA3zt4TxfOOFtfp2Ep1zCaWzEjmHZT4sA28EKWKdYASuGJ6e5hRK4InBFoOi7iql+C5rsQJp30FttIP2ZvKeEcTcl1KVqmOy1oCsu1BUHzFX4Td0bgZokDY7torVAR+pjGalPZFTGahjrtNCYpUeCl/xSQUA/TN2FJgXXJBZJIO2pDNt00ZQTDlT8Q0V7sbFmIDtV91QZ8IPqC7+qG+/lflBAYq7jIuu1IibQWWrAtlzE3RCrTLwroSo+UJJ0X8L8mA0GydemaKHfFX5VwOirNcUEFiZszA7be7BQCWxNykMZy7MOGJwVX51o4zvLM46YgGW46K839zRsKY8C8MUpG8kPdx/SiR6LVRITYPn50m6JqH5lzgNfmrLZhj2R7q8zKVJMYGXWYeLIJDlvFciLHvjCuAfO1SKem2CbHrSwOGmLCbD8jILP4b2sT9dZJTA4KxxI/1llnIbkB9FzQ/Vd5YaYQPYbBa7rQll2kPteQTDBnjEx+LyrwghVTO8o+xNuOA0ZHvn057KYgP+iH3RCmokfypJDL4gsM81mottCVYJGX2F70JSt09wERiQwnOkBiy5GO+Vgcn37qvc0pN0VBlcJc2BuxKZLntGf0RWBKwKrG+hm+YB3TAa8azbgnVOU7jkoSOjdPQcAJPatT+WAfEgAAAAASUVORK5CYII="
    //             width="26"
    //           />
    //           SYNC
    //         </Box>
    //         {row.original.onfsuccess > 0 ? (
    //           <span
    //             style={{
    //               color: "green",
    //               display: "flex",
    //               alignItems: "center",
    //               fontWeight: "600",
    //             }}
    //           >
    //             success
    //           </span>
    //         ) : (
    //           ""
    //         )}
    //       </div>
    //     ) : null,
    // },
    // {
    //   header: "ID",
    //   accessorKey: "Posid", // pass posid for column filter and sort.
    //   size: 120,
    //   Cell: checkUserPermission(PERMISSION_EDIT)
    //     ? ({ row }) => (
    //         <Box
    //           component="span"
    //           sx={(theme) => ({
    //             borderRadius: "0.3rem",
    //             color: "#343f62",
    //             maxWidth: "18ch",
    //             fontWeight: "700",
    //             textDecoration: "underline",
    //             textUnderlineOffset: "3px",
    //             p: "0.3rem",
    //             cursor: "pointer",
    //           })}
    //          onClick={() => navigate(`/manage-sales/${row.original.ID}`)}
    //         >
    //           {row.original.Posid}
    //         </Box>
    //       )
    //     : null,
    //   filterFn: "contains",
    // },
    {
      header: "Last Updated Date",
      accessorKey: "LastUpdatedDate",
      Cell: ({ row }) =>
        moment(row.original.LastUpdatedDate).format("MM/DD/YYYY h:mm A"),
    },
    {
      header: "Created Date",
      accessorKey: "CreatedDate",
      Cell: ({ row }) =>
        moment(row.original.CreatedDate).format("MM/DD/YYYY h:mm A"),
    },
    {
      header: "Customer",
      accessorKey: "CustomerName",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={(theme) => ({
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            fontWeight: "700",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
          })}
          onClick={() =>
            navigate(`/manage-customers/${row.original.Customerid}`)
          }
        >
          {row.original.CustomerName}
        </Box>
      ),
    },
    {
      header: "Delivery Status",
      accessorKey: "IDdeliveryStatus",
      headerTooltip: "IDdeliveryStatus",
      // Cell: ({ row }) => (
      //   <>
      //     {/* {showDeliverySelect?.id !== row.original.ID ? ( */}
      //     <>
      //       {
      //         deliveryStatusList?.find(
      //           (el) => el.value == row.original?.IDdeliveryStatus
      //         )?.label
      //       }
      //     </>
      //   </>
      // ),
    },
    {
      header: "Invoice No",
      accessorKey: "InvoiceNo",
      Cell: ({ row }) => (
        // <>
        //   <Link
        //     className="text-warning word-break-data"
        //     to={`/sales-receipt/${row.original.ID}`}
        //   >
        //     {row.original.InvoiceNo}
        //   </Link>
        // </>
        <Box
          component="span"
          sx={(theme) => ({
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            fontWeight: "700",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
          })}
          onClick={() => navigate(`/sales-receipt/${row.original.Posid}`)}
        >
          {row.original.InvoiceNo}
        </Box>
      ),
    },
    {
      header: "Type",
      accessorKey: "SalesType",
    },
    {
      header: "Created By",
      accessorKey: "CreatedBy",
    //   Cell: checkUserPermission(PERMISSION_EDIT) 
    //   ? ({ row }) => (
    //       <Box
    //         component="span"
    //         sx={(theme) => ({
    //           borderRadius: "0.3rem",
    //           color: "#343f62",
    //           maxWidth: "18ch",
    //           fontWeight:"700",
    //           textDecoration:"underline",
    //           textUnderlineOffset: "3px",
    //           p: "0.3rem",
    //           cursor: "pointer",
    //         })}
    //         onClick={() =>
    //           navigate(`/manage-employee/${loginuserid}`)
    //         }
    //       >
    //         {row.original.CreatedBy}
    //       </Box>
    //     ) 
    //   : null,
    // filterFn: "contains",
    },
    {
      header: "Status",
      accessorKey: "StatusName",
      Cell: ({ row }) =>
        row.original.StatusName == "Paid" ? (
          <Box
            // class="text-warning word-break-data"
            // to={`/manage-suppliers/${row.original.SupplierId}`}
            component="span"
            sx={(theme) => ({
              // backgroundColor: '#E8F7F5',
              borderRadius: "0.3rem",
              color: "var(--success-main-color)",
              maxWidth: "9ch",
              p: "0.3rem",
              fontWeight: "bold",
            })}
          >
            {row.original.StatusName}
          </Box>
        ) : row.original.StatusName == "Completed" ? (
          <Box
            component="span"
            sx={(theme) => ({
              // backgroundColor: 'var(--primary-color-50)',
              borderRadius: "0.3rem",
              color: "var(--neutral-main-color)",
              maxWidth: "15ch",
              p: "0.3rem",
              fontWeight: "bold",
            })}
          >
            {row.original.StatusName}
          </Box>
        ) : row.original.StatusName == "Pending" ? (
          <Box
            component="span"
            sx={(theme) => ({
              //  backgroundColor: '#FEF7E2',
              borderRadius: "0.3rem",
              color: "var(--error-main-color)",
              maxWidth: "9ch",
              p: "0.3rem",
              fontWeight: "bold",
            })}
          >
            {row.original.StatusName}
          </Box>
        ) : row.original.StatusName == "Void" ? (
          <Box
            component="span"
            sx={(theme) => ({
              // backgroundColor: '#FBECF0',
              borderRadius: "0.3rem",
              color: "#e63462",
              maxWidth: "9ch",
              p: "0.3rem",
              fontWeight: "bold",
            })}
          >
            {row.original.StatusName}
          </Box>
        ) : (
          ""
        ),
    },
    {
      header: "Total",
      accessorKey: "Total",
      Cell: ({ row }) =>
        row.original.Total > 0 ? parseFloat(row.original.Total).toFixed(2) : 0,
    },
    {
      header: "Amount Paid",
      accessorKey: "Paymentamount",
      Cell: ({ row }) =>
        row.original.Paymentamount > 0
          ? parseFloat(row.original.Paymentamount).toFixed(2)
          : 0,
    },
    // {
    //   header: "Credit Used",
    //   accessorKey: "CreditApplied",
    //   size: 100,
    //   Cell: ({ row }) =>
    //     row.original.CreditApplied > 0
    //       ? parseFloat(row.original.CreditApplied).toFixed(2)
    //       : 0,
    // },
    {
      header: "Open Balance",
      accessorKey: "AmountDue",
      // Cell: ({ row }) =>
      //   row.original.SaleTypeId == 1
      //     ? row.original.AmountDue > 0
      //       ? parseFloat(row.original.AmountDue).toFixed(2)
      //       : 0
      //     : "-",
    },
    {
      header: "Billing Address",
      accessorKey: "BillingAddress",
    },
    {
      header: "Location",
      accessorKey: "Location",
      // Cell: ({ row }) => row.original.SaleTypeId == 1 ? row.original.AmountDue > 0 ? parseFloat(row.original.AmountDue).toFixed(2) : 0 : "-",
    },
    {
      header: "Due Date",
      accessorKey: "DueDate",
      Cell: ({ row }) => !row.original.DueDate || row.original.DueDate === "0000-00-00" ? "": moment(row.original.DueDate).format("MM-DD-YYYY"),
    },
    {
      header: "Aging",
      accessorKey: "Aging",
      Cell: ({ row }) => (row.original > 0 ? row.original : ""),
    },
    {
      header: "Ecom Orders",
      accessorKey: "isEcommerce",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={(theme) => ({
            borderRadius: "0.3rem",
            maxWidth: "9ch",
            p: "0.3rem",
            fontWeight: "bold",
            // color: row.original.isEcommerce > 0 ? "var(--success-main-color)" : "var(--error-main-color)",
          })}
        >
          {row.original.isEcommerce > 0 ? "Ecommerce Order" : "Portal"}
        </Box>
      ),
    },
    // {
    //   header : "SyncStatus",
    //   accessorKey : "SyncStatus"
    // },
    {
      header: "Quickbooks Sync Status",
      accessorKey: "SyncStatusName",

      Cell: ({ row }) =>
        row.original.SyncStatusName == "Completed" ? (
          <Box
            // class="text-warning word-break-data"
            // to={`/manage-suppliers/${row.original.SupplierId}`}
            component="span"
            sx={(theme) => ({
              // backgroundColor: '#E8F7F5',
              borderRadius: "0.3rem",
              color: "var(--success-main-color)",
              maxWidth: "9ch",
              p: "0.3rem",
              fontWeight: "bold",
            })}
          >
            {row.original.SyncStatusName}
          </Box>
        ) : row.original.SyncStatusName == "Failed" ? (
          <Box
            component="span"
            sx={(theme) => ({
              //  backgroundColor: '#FEF7E2',
              borderRadius: "0.3rem",
              color: "var(--error-main-color)",
              maxWidth: "9ch",
              p: "0.3rem",
              fontWeight: "bold",
            })}
          >
            {row.original.SyncStatusName}
          </Box>
        ) : (
          ""
        ),
      // enableGrouping: false, //do not let this column be grouped
    },
    // {
    //   header: "Home Delivery Number",
    //   accessorKey: "DeliveryHomeNumber",
    // },
    // {
    //   header: "Profile",
    //   accessorKey: "Image",
    //   Cell: ({ row }) => (
    //     <>
    //       <a href={row.original.Image} target="_blank">
    //         <img
    //           src={row.original.Image}
    //           alt="Profile Image"
    //           style={{
    //             maxWidth: "30px",
    //             maxHeight: "70px",
    //             margin: "5px",
    //           }}
    //           onError={(e) => {
    //             e.target.onerror = null;
    //             e.target.src = Noimage;
    //           }}
    //         ></img>
    //       </a>
    //     </>
    //   ),
    // },
    // {
    //   header: "Created On",
    //   accessorKey: "CreatedDate",
    //   Cell: ({ row }) => formatDate(row.original.CreatedDate),
    // },
  ]);

  // function handleCheckboxChange(columnName) {
  //   if (hiddenColumns.includes(columnName)) {
  //     setHiddenColumns(hiddenColumns.filter((column) => column !== columnName));
  //   } else {
  //     setHiddenColumns([...hiddenColumns, columnName]);
  //   }
  // }

  // generate new columns according to hiddenColumns data and pass it as datatable column

  // const filteredColumns = columns.filter(
  //   (column) => !hiddenColumns.includes(column.name.replace(/\s+|-|\/|#/g, ""))
  // );

  // const handlePerRowsChange = async (page, newPerPage) => {
  //   setperPageSize(newPerPage);
  //   setCurrentPage(page);
  //   handleListData(
  //     page,
  //     newPerPage,
  //     searchtext,
  //     sortingId,
  //     sortingDirection,
  //     startingDate,
  //     endingDate,
  //     salesTypeID,
  //     customerID
  //   );
  // };

  // const handlePageChange = (page) => {
  //   setCurrentPage(page);
  //   handleListData(
  //     page,
  //     perPageSize,
  //     searchtext,
  //     sortingId,
  //     sortingDirection,
  //     startingDate,
  //     endingDate,
  //     salesTypeID,
  //     customerID
  //   );
  // };

  // const handleSort = (e, sortingDirection) => {
  //   setSortingId(e.id);
  //   setSortingDirection(sortingDirection);
  //   handleListData(
  //     1,
  //     perPageSize,
  //     searchtext,
  //     e.id,
  //     sortingDirection,
  //     startingDate,
  //     endingDate,
  //     salesTypeID,
  //     customerID
  //   );
  // };
  const handleChangeSalesType = (event) => {
    setSalesTypeValue(event);
    setSalesTypeID(event?.value);
  };
  const handelcloseMenu = () => {
    setDeliveryModalOpen(false);
    handleSearchAccordingToDate();
    // closeMenuofrow();
  };

  const handleChangeCustomer = (event) => {
    setCustomerValue(event);
    setCustomerID(event?.value);
  };

  let salesTypeDropdownOption = [];
  const SalesTypeDropdown = saletype.map((u, i) => {
    salesTypeDropdownOption[i] = { label: u.SalesType, value: u.ID };
  });

  const customerDropDown = custoptions.map((option) => ({
    value: option.Id,
    label:
      option.CompanyName +
      " (" +
      (option.FirstName + " " + option.LastName) +
      ")",
    address: option.Address1,
    email: option.Email,
  }));

  useEffect(() => {
    axios
      .get(`${config.salesconfigBaseUrl}/sales/saletype`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((response) => {
        setSaletype(response.data.ResponseData);
        console.log(response.data.ResponseData, "===> setSaletype");
      })
      .catch((error) => {
        console.log(error);
      });

    // customer drop down
    axios
      .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        setCustOptions(response.data.ResponseData);
        console.log(response.data.ResponseData, "===> setCustOptions");
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(
        `${
          config.salesconfigBaseUrl
        }/sales/salessummary?locationid=${localStorage.getItem("Location")}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        setSalesSummary(response.data.ResponseData[0]);
        console.log(response.data.ResponseData, "==> setSalesSummary");
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const renderRowActionMenuItems = ({ row, closeMenu }) => [
    checkUserPermission(PERMISSION_EDIT) &&
    row.original.StatusName !== "Void" ? (
      <MenuItem
        key="edit"
        onClick={() => navigate(`/manage-sales/${row.original.ID}`)}
      >
        Edit
      </MenuItem>
    ) : (
      ""
    ),
    checkUserPermission(PERMISSION_DELETE) ? (
      <MenuItem
        className="confirm-text"
        to="#"
        // key="delete"

        title="Delete"
        data-bs-toggle="modal"
        data-bs-target="#DeleteConfirmationModal"
        onClick={() =>
          handleDeletePopup(
            row.original.SaleTypeId,
            row.original.ID,
            row.original.QuickBookId,
            "",
            "singlerowdelete"
          )
        }
      >
        Delete
      </MenuItem>
    ) : (
      ""
    ),
    checkUserPermission("/Delivery-Status") ? (
      <MenuItem
        className="confirm-text"
        to="#"
        // key="delete"

        title="Delete"
        data-bs-toggle="modal"
        data-bs-target="#DeleteConfirmationModal"
        onClick={() => handleDeliveryPopup(row.original.ID, closeMenu)}
      >
        Delivery Status
      </MenuItem>
    ) : (
      ""
    ),
    checkUserPermission(PERMISSION_RECEIPT) ? (
      <MenuItem
        className="confirm-text"
        to="#"
        // key="delete"

        onClick={() => navigate(`/sales-receipt/${row.original.Posid}`)}
      >
        Receipt
      </MenuItem>
    ) : (
      ""
    ),


 
      // <MenuItem
      //   className="confirm-text"
      //   to="#"
      //   // key="delete"

      //   onClick={() => navigate(`/Driver-Daily-sheet`)}
      // >
      //   Driver Daily Sheet
      // </MenuItem>,

    // checkUserPermission(PERMISSION_CUSTOMER_CUSTOM_INVOICE)
    row.original.CustomerCustomInvoice > 0 ? (
      <MenuItem
        className="confirm-text"
        to="#"
        // key="delete"
        onClick={() => {
          closeMenu();
          window.open(
            `/ecomcustominvoice/?i=${generateFinalKey(
              row.original.CustomerCustomInvoice
            )}&type=CustomerCustomInvoice`,
            "_blank",
            "rel=noopener noreferrer"
          );
          // navigate(`/ecomcustominvoice/?i=${generateFinalKey(row.original.CustomerCustomInvoice)}&type=CustomerCustomInvoice`,  '_blank')
        }}
      >
        Customer Custom Invoice
      </MenuItem>
    ) : (
      ""
    ),
    row.original.Receipt && (
      <NavLink to={`${row.original.Receipt}`}>
        <MenuItem className="confirm-text" to="#" target="_blank">
          Attachment
        </MenuItem>
      </NavLink>
    ),
  ];

  const renderTopToolbarCustomActions = ({ table }) => (
    <Box
      sx={{
        display: "flex",
        gap: "1rem",
        p: "0.5rem",
        flexWrap: "wrap",
      }}
    >
      {console.log(table, "tables")}

      {(table.getIsSomeRowsSelected() || table.getIsAllRowsSelected()) &&
      checkUserPermission(PERMISSION_DELETE) ? (
        <Button
          class="btn btn-sm btn-secondary"
          style={{ display: "flex" }}
          // size="small"
          // disabled={
          //   !table.getIsSomeRowsSelected() &&
          //   !table.getIsAllRowsSelected()
          // }
          onClick={() =>
            handleDeletePopup(
              "",
              "",
              "",
              table.getSelectedRowModel().rows,
              "multipleRowInactive"
            )
          }
          startIcon={<DeleteIcon />}
          variant="contained"
        >
          Delete
        </Button>
      ) : (
        ""
      )}
      {/* <Button
        size="small"
        onClick={() =>
          setPagination({ ...pagination, pageSize: totalRows })
        }
        variant="contained"
      >
        Get All Data
      </Button> */}
    </Box>
  );

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Sales</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">Sales List</li>
              </ul>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "6px",
            }}
          >
            {checkUserPermission("export-button") ? (
              <button
                // className="btn btn-added pull-right"
                className="btn btn-sm btn-outline-dark btn-sm pull-right mr-3"
                style={{ width: "max-content" }}
                onClick={() => onBtExport([], "AllData")}
              >
                <i
                  className="fa fa-download mr-2"
                  style={{ color: "#111930" }}
                ></i>
                Export Visible Column
                {/* <i class="fa-thin fa-download"></i> */}
              </button>
            ) : (
              ""
            )}
            {checkUserPermission(PERMISSION_ADD) ? (
              <div className="me-2">
                <Link className="btn btn-sm btn-primary" to={`/manage-sales`}>
                  <i className="fa fa-plus me-2 lg"></i> New Sales
                </Link>
              </div>
            ) : (
              ""
            )}

            {checkUserPermission(PERMISSION_RECEIVEPAYMENT) ? (
              <div className="me-2">
                <Link class="btn btn-sm btn-primary" to="/receive-payment/">
                  <i className="fa fa-dollar me-2 lg"></i> Receive Payment
                </Link>
              </div>
            ) : (
              ""
            )}

            <div className="btn-group btn-group-sm pull-right me-2">
              {
                // checkUserPermission(PERMISSION_BATCHSALES) ||
                checkUserPermission(PERMISSION_LOOKUPRECEIPT) ||
                //  checkUserPermission(PERMISSION_CUSTOMFIELD) ||
                checkUserPermission(PERMISSION_ALLRECEIPT) ? (
                  <button
                    type="button"
                    className="btn btn-outline-dark dropdown-toggle me-1"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    style={{ borderRadius: "5px" }}
                  >
                    More
                  </button>
                ) : (
                  " "
                )
              }

              {/* <button type="button" className="btn btn-outline-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" >
                  <i className="fas fa-ellipsis-h me-1 fs-6"></i>
                </button> */}
              <ul className="dropdown-menu">
                {/* {checkUserPermission(PERMISSION_DELIVERIES) ? (
                  <li>
                    <Link
                      to="/deliveries"
                      title="Delivery Orders"
                      className="dropdown-item"
                    >
                      <i className="far fa-list-alt fs-6 me-1 mt-1"></i>{" "}
                      Delivery Orders
                    </Link>
                  </li>
                ) : (
                  ""
                )} */}

                {/* #27052024HideSection #Comment For Phase-I #HIDE-27-05-2024 #Line 2217-2226
                {checkUserPermission(PERMISSION_BATCHSALES) ? (
                  <li>
                    <Link
                      to="/batch-sales"
                      title="Batch sale"
                      className="dropdown-item"
                    >
                      <i className="fas fa-shopping-bag fs-6 me-1 mt-1"></i>{" "}
                      Batch sale
                    </Link>
                  </li>
                ) : (
                  ""
                )} */}

                {checkUserPermission(PERMISSION_LOOKUPRECEIPT) ? (
                  <li>
                    <Link
                      className="dropdown-item"
                      data-bs-target="#LookupReceiptSaleModal"
                      data-bs-toggle="modal"
                    >
                      <i className="far fa-file-alt fs-6 me-1 mt-1"></i> Lookup
                      Receipt
                    </Link>
                  </li>
                ) : (
                  ""
                )}

                {checkUserPermission(PERMISSION_LOOKUPRECEIPT) ? (
                  <li>
                    <Link
                      to="/sales-receipt/0"
                      title="Show last sale receipt"
                      className="dropdown-item"
                    >
                      <i className="fas fa-receipt fs-6 me-1 mt-1"></i>Show last
                      sale receipt
                    </Link>
                  </li>
                ) : (
                  ""
                )}
                {/* <li>
                    <Link to="/sales-customer-facing-display" title="Customer Facing Display" className="dropdown-item">
                      <i className="fas fa-desktop fs-6 me-1"></i> Customer Facing Display
                    </Link>
                  </li> */}

                {/* #27052024HideSection #Comment For Phase-I #HIDE-27-05-2024 #Line 2217-2226
                {checkUserPermission(PERMISSION_CUSTOMFIELD) ? (
                  <li>
                    <Link
                      to="/custom-field-sales-configuration"
                      title="Custom Field Configuration"
                      className="dropdown-item"
                    >
                      <i className="fas fa-wrench fs-6 me-1 mt-1"></i> Custom
                      Field Configuration
                    </Link>
                  </li>
                ) : (
                  ""
                )} */}

                {checkUserPermission(PERMISSION_ALLRECEIPT) ? (
                  <li>
                    <Link
                      to="/sales-all-receipt"
                      title="Show all receipts for today"
                      className="dropdown-item"
                    >
                      <i className="far fa-file-alt fs-6 me-1 mt-1"></i> Show
                      all receipts for today
                    </Link>
                  </li>
                ) : (
                  ""
                )}



{checkUserPermission(PERMISSION_ALLRECEIPT) ? (
                   <li>
                   <Link
                     to="/Driver-Daily-sheet"
                     title="Show all receipts for today"
                     className="dropdown-item"
                   >
                     <i className="far fa-file-alt fs-6 me-1 mt-1"></i> 
                     Driver Daily Sheet 
                   </Link>
                 </li>
                ) : (
                  ""
                )}


                
                



              </ul>
            </div>
            {/* <div className="btn-group btn-group-sm pull-right me-2">
              <button
                type="button"
                className="btn btn-outline-primary dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                style={{ borderRadius: "5px" }}
              >
                <i className="fa fa-cog"></i> &nbsp;
              </button> */}
            {/* <div className="dropdown-menu">
                  {columns.map((column) =>
                    // omit Action column
                    column.name.replace(/\s+|-|\/|#/g, "") !== "Action" ? (
                      <div
                        key={column.name.replace(/\s+|-|\/|#/g, "")}
                        className="form-check ms-2 mt-1"
                      >
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`checkbox-${column.name.replace(
                            /\s+|-|\/|#/g,
                            ""
                          )}`}
                          value={column.name.replace(/\s+|-|\/|#/g, "")}
                          checked={
                            !hiddenColumns.includes(
                              column.name.replace(/\s+|-|\/|#/g, "")
                            )
                          } // check all checkboxes which are not include in hiddenColumns
                          onChange={() =>
                            handleCheckboxChange(
                              column.name.replace(/\s+|-|\/|#/g, "")
                            )
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`checkbox-${column.name.replace(
                            /\s+|-|\/|#/g,
                            ""
                          )}`}
                        >
                          {column.name}
                        </label>
                      </div>
                    ) : (
                      ""
                    )
                  )}
                </div> */}
            {/* </div> */}
          </div>

          {checkUserPermission("hide-cards") && (
            <div className="row">
              <div className="col-lg-3 col-sm-3 col-12">
                <div className="dash-widget dash-widget-custom">
                  <div className="dash-widgetimg">
                    <span>
                      <img src={Dash1} alt="img" />
                    </span>
                  </div>
                  <div className="dash-widgetcontent">
                    <p className="p-20">
                      $
                      <span className="counters">
                        <CountUp
                          className="p-20"
                          end={salesSummary?.EstimateAmount}
                        />
                      </span>
                      <p className="p-medium">
                        {salesSummary.EstimateCount} Estimate
                      </p>
                    </p>
                  </div>
                </div>
              </div>
              {/* <div className="col-lg-2 col-sm-4 col-12">
              <div className="dash-widget dash1">
                <div className="dash-widgetimg">
                  <span>
                    <img src={Dash2} alt="img" />
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <p>
                    $
                    <span className="counters">
                      <CountUp end={salesSummary.UnbilledActivityAmount} />
                    </span>
                  </p>
                  <h6>{salesSummary.UnbilledActivityCount} Unbilled Activity </h6>
                </div>
              </div>
            </div> */}
              <div className="col-lg-3 col-sm-3 col-12">
                <div className="dash-widget dash-widget-custom dash2">
                  <div className="dash-widgetimg">
                    <span>
                      <img src={Dash3} alt="img" />
                    </span>
                  </div>
                  <div className="dash-widgetcontent">
                    <p className="p-20">
                      $
                      <span className="counters">
                        <CountUp
                          className="p-20"
                          end={salesSummary.OverdueAmount}
                        />
                      </span>
                      <p className="p-medium">
                        {salesSummary.OverdueCount} Overdue
                      </p>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-3 col-12">
                <div className="dash-widget dash-widget-custom dash3">
                  <div className="dash-widgetimg">
                    <span>
                      <img src={Dash4} alt="img" />
                    </span>
                  </div>
                  <div className="dash-widgetcontent">
                    <p className="p-20">
                      $
                      <span className="counters">
                        <CountUp
                          className="p-20"
                          end={salesSummary.OpenInvoicesAmount}
                        />
                      </span>
                      <p className="p-medium">
                        {salesSummary.OpenInvoicesCount} Open Invoices
                      </p>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-3 col-12">
                <div className="dash-widget dash-widget-custom dash2">
                  <div className="dash-widgetimg">
                    <span>
                      <img src={Dash2} alt="img" />
                      {/* <img src={Dash4} alt="img" /> */}
                    </span>
                  </div>
                  <div className="dash-widgetcontent">
                    <p className="p-20">
                      $
                      <span className="counters">
                        <CountUp
                          className="p-20"
                          end={salesSummary.LastPaidCountAmount}
                        />
                        {/* {salesSummary.LastPaidCountAmount} */}
                      </span>
                      <p className="p-medium">
                        {salesSummary.LastPaidCount} Paid Last 30 Days
                      </p>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-md-12 d-flex justify-content-between">
              <div className="d-flex flex-wrap col-md-10">
                <div className="col-md-2 mt-1">
                  Date Filter:
                  <Select
                    defaultValue={quickBookOptions}
                    onChange={(event) => {
                      handleQuickBookChange(event);
                    }}
                    options={options}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    // isClearable={true}
                    // hideSelectedOptions={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select"
                  />
                </div>
                {quickBookOptions?.value == 2 && (
                  <>
                    <div className="ml-2 col-md-2">
                      Custom Start Date:
                      {/* <Flatpickr
                        type="date"
                        className="form-control form-control-sm mt-1"
                        id="StartDate"
                        name="StartDate"
                        onChange={(event) =>
                          handleChangeCustomStartingDate(event)
                        }
                        value={
                          moment(customStartingDate).format(
                            "YYYY-MM-DDT00:00:00.000"
                          ) + "Z"
                        }
                             options={{
                        dateFormat: "m/d/Y",
                        altInput: true,
                        altFormat: "m/d/Y",
                      }}
                      /> */}

                      
<CommonDatePicker FinalDate={startingDate} handleDateChange={handleChangeCustomStartingDate}/>
                    </div>
                    <div className="ml-2 col-md-2">
                      Custom End Date:
                      {/* <Flatpickr
                        type="date"
                        className="form-control form-control-sm mt-1"
                        id="EndDate"
                        name="EndDate"
                        value={
                          moment(customEndingDate).format(
                            "YYYY-MM-DDT00:00:00.000"
                          ) + "Z"
                        }
                        onChange={(event) =>
                          handleChangeCustomEndingDate(event)
                        }
                             options={{
                        dateFormat: "m/d/Y",
                        altInput: true,
                        altFormat: "m/d/Y",
                      }}
                      /> */}
                      <CommonDatePicker FinalDate={customEndingDate} handleDateChange={handleChangeCustomEndingDate}/>
                    </div>
                  </>
                )}
                {quickBookOptions?.value == 2 && (
                  <div className="ml-2">
                    <button style={{marginTop:"22px"}}
                      className="btn btn-dark btn-sm w-70"
                      onClick={() => handleSearchAccordingToDate()}
                    >
                      {" "}<i class="fa fa-search"></i>{" "}
                    </button>
                  </div>
                )}
                <div className="ml-2 col-md-2">
                  Sales Type:
                  <Select
                    // defaultValue={salesTypeValue}
                    onChange={(event) => {
                      handleChangeSalesType(event);
                    }}
                    value={salesTypeDropdownOption?.find(
                      (el) => el.value == salesTypeID
                    )}
                    options={salesTypeDropdownOption}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select mt-1"
                  />
                </div>
                <div
                  className={
                    quickBookOptions?.value == 2
                      ? "ml-2 mb-2 col-md-2 "
                      : "ml-2 mb-2 col-md-4 "
                  }
                >
                  Customer:
                  <Select
                    defaultValue={customerValue}
                    onChange={(event) => {
                      handleChangeCustomer(event);
                    }}
                    options={customerDropDown}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select mt-1"
                  />
                </div>

                <div
                  className={
                    quickBookOptions?.value == 2
                      ? " mb-2 col-md-2 mr-2"
                      : "ml-2 mb-2 col-md-2 mr-2"
                  }
                >
                  Status:
                  <Select
                    // defaultValue={status}
                    onChange={(e) => {
                      setStatus(e?.value);
                    }}
                    value={statusoption?.find((el) => el.value == status)}
                    options={statusoption}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    // isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select mt-1"
                  />
                </div>
                {/* <div >

                  <input type="toggel" />
                    Show Ecom Order
                  </div> */}
                <div
                  // class="form-check form-switch ml-3"
                  // style={{ alignSelf: "center", fontSize: "small" }}
                  className={
                    quickBookOptions?.value == 2 ? "mb-2 col-md-2" : "ml-2"
                  }
                >
                  Show Ecom Order:
                  <Select
                    defaultValue={ishowEcomOptions?.find(
                      (el) => el.value === isShowEcomOrders
                    )}
                    onChange={(e) => {
                      setIsShowEcomOrders(e?.value);
                    }}
                    options={ishowEcomOptions}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    // isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select mt-1"
                  />
                </div>

              </div>
                <div
                  className="mt-4 cursor-pointer"
                  onClick={() =>
                    handleSaveColumnOrder(
                      loginuserid,
                      "sales",
                      columnOrder,
                      token,
                      columnVisibility
                    )
                  }
                  title="Lock Your Sequence"
                  // onMouseEnter={() => setIcon(ColumnOrderIconHover)}
                  // onMouseLeave={() => setIcon(ColumnOrderIcon)}
                >
                  <i class="fa fa-lock columnsLock fs-4"></i>
                </div>
            </div>
          </div>

          {/* Customer list */}
          <div className="card">
            <div className="card-body custom-table-css">
              <div className="table-responsive" style={{position:"relative", zIndex:'0'}}>
                <CommonMatrialReactTableServerSideRender
                  MainHeading="Sonar POS"
                  ReportHeading="Sales List"
                  columns={columns}
                  data={data}
                  // startdate={startdate}
                  // enddate={enddate}
                  columnGrouping={[]}
                  columnsVisibility={{}}
                  enableRowActions={
                    checkUserPermission(PERMISSION_EDIT) ||
                    checkUserPermission(PERMISSION_DELETE) ||
                    checkUserPermission("/Delivery-Status") ||
                    checkUserPermission(PERMISSION_RECEIPT)
                  }
                  enableRowSelection={true}
                  renderRowActionMenuItems={renderRowActionMenuItems}
                  renderTopToolbarCustomActions={renderTopToolbarCustomActions}
                  density="comfortable"
                  showGlobalFilter={true}
                  showColumnFilters={false}
                  expanded={true}
                  pagination={{ pageIndex: 0, pageSize: 25 }}
                  rowCount={rowCount}
                  setColumnFilters={setColumnFilters} // for termp comment filteron column
                  setGlobalFilter={setGlobalFilter}
                  setPagination={setPagination}
                  setSorting={setSorting}
                  setColumnOrder={setColumnOrder}
                  setColumnVisibility={setColumnVisibility} //setColumnVisibility
                  columnPinning={{}} //{ left: ['CustomerName'], right:['SyncStatusName'] }
                  state={{
                    columnFilters, // for termp comment filteron column
                    // globalFilter,
                    isLoading,
                    pagination,
                    showAlertBanner: isError,
                    showProgressBars: isRefetching,
                    sorting,
                    columnOrder,
                    columnVisibility,
                  }}
                />

                {/* <MaterialReactTable
                  columns={columns}
                  data={data}
                  // positionPagination='top'
                  enableColumnResizing
                  enableGrouping
                  enableStickyHeader
                  enableStickyFooter
                  enableRowSelection
                  enableColumnOrdering
                  enableRowActions={
                    checkUserPermission(PERMISSION_EDIT) ||
                    checkUserPermission(PERMISSION_DELETE) ||
                    checkUserPermission("/Delivery-Status") ||
                    checkUserPermission(PERMISSION_RECEIPT)
                  }
                  positionGlobalFilter="left"
                  renderRowActionMenuItems={({ row, closeMenu }) => [
                    checkUserPermission(PERMISSION_EDIT) &&
                    row.original.StatusName !== "Void" ? (
                      <MenuItem
                        key="edit"
                        onClick={() =>
                          navigate(`/manage-sales/${row.original.ID}`)
                        }
                      >
                        Edit
                      </MenuItem>
                    ) : (
                      ""
                    ),
                    checkUserPermission(PERMISSION_DELETE) ? (
                      <MenuItem
                        className="confirm-text"
                        to="#"
                        // key="delete"

                        title="Delete"
                        data-bs-toggle="modal"
                        data-bs-target="#DeleteConfirmationModal"
                        onClick={() =>
                          handleDeletePopup(
                            row.original.SaleTypeId,
                            row.original.ID,
                            row.original.QuickBookId,
                            "",
                            "singlerowdelete"
                          )
                        }
                      >
                        Delete
                      </MenuItem>
                    ) : (
                      ""
                    ),
                    checkUserPermission("/Delivery-Status") ? (
                      <MenuItem
                        className="confirm-text"
                        to="#"
                        // key="delete"

                        title="Delete"
                        data-bs-toggle="modal"
                        data-bs-target="#DeleteConfirmationModal"
                        onClick={() =>
                          handleDeliveryPopup(row.original.ID, closeMenu)
                        }
                      >
                        Delivery Status
                      </MenuItem>
                    ) : (
                      ""
                    ),
                    checkUserPermission(PERMISSION_RECEIPT) ? (
                      <MenuItem
                        className="confirm-text"
                        to="#"
                        // key="delete"

                        onClick={() =>
                          navigate(`/sales-receipt/${row.original.ID}`)
                        }
                      >
                        Receipt
                      </MenuItem>
                    ) : (
                      ""
                    ),

                    // checkUserPermission(PERMISSION_CUSTOMER_CUSTOM_INVOICE)
                    row.original.CustomerCustomInvoice > 0 ? (
                      <MenuItem
                        className="confirm-text"
                        to="#"
                        // key="delete"
                        onClick={() => {
                          closeMenu();
                          window.open(
                            `/ecomcustominvoice/?i=${generateFinalKey(
                              row.original.CustomerCustomInvoice
                            )}&type=CustomerCustomInvoice`,
                            "_blank",
                            "rel=noopener noreferrer"
                          );
                          // navigate(`/ecomcustominvoice/?i=${generateFinalKey(row.original.CustomerCustomInvoice)}&type=CustomerCustomInvoice`,  '_blank')
                        }}
                      >
                        Customer Custom Invoice
                      </MenuItem>
                    ) : (
                      ""
                    ),
                    row.original.Receipt && (
                      <NavLink to={`${row.original.Receipt}`}>
                        <MenuItem
                          className="confirm-text"
                          to="#"
                          target="_blank"
                        >
                          Attachment
                        </MenuItem>
                      </NavLink>
                    ),
                  ]}
                  renderTopToolbarCustomActions={({ table }) => (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "1rem",
                        p: "0.5rem",
                        flexWrap: "wrap",
                      }}
                    >
                      {console.log(table, "tables")}

                      {(table.getIsSomeRowsSelected() ||
                        table.getIsAllRowsSelected()) &&
                      checkUserPermission(PERMISSION_DELETE) ? (
                        <Button
                          class="btn btn-sm btn-secondary"
                          style={{ display: "flex" }}
                          // size="small"
                          // disabled={
                          //   !table.getIsSomeRowsSelected() &&
                          //   !table.getIsAllRowsSelected()
                          // }
                          onClick={() =>
                            handleDeletePopup(
                              "",
                              "",
                              "",
                              table.getSelectedRowModel().rows,
                              "multipleRowInactive"
                            )
                          }
                          startIcon={<DeleteIcon />}
                          variant="contained"
                        >
                          Delete
                        </Button>
                      ) : (
                        ""
                      )}
                      // {/* <Button
                      //   size="small"
                      //   onClick={() =>
                      //     setPagination({ ...pagination, pageSize: totalRows })
                      //   }
                      //   variant="contained"
                      // >
                      //   Get All Data
                      // </Button> */}
                {/* </Box>
                  )}
                  // rowVirtualizerOptions={{
                  //   overscan: 10, //adjust the number or rows that are rendered above and below the visible area of the table
                  //   estimateSize: () => 100, //if your rows are taller than normal, try tweaking this value to make scrollbar size more accurate
                  // }}
                  muiTableContainerProps={{
                    sx: { maxHeight: "fit-content" },
                  }}
                  initialState={{
                    density: "comfortable",
                    showGlobalFilter: true,
                    expanded: true, //expand all groups by default
                    // grouping: [""], //an array of columns to group by by default (can be multiple)
                    pagination: { pageIndex: 0, pageSize: 25 },
                    // sorting: { id: "Name", desc: false }, //sort by state by default
                  }}
                  //For color of each alternative row(Zebra-column)
                  muiTableBodyProps={{
                    sx: () => ({
                      "& tr:nth-of-type(even)": {
                        backgroundColor:
                          "var(--datatable-row-background-color)",
                        //'rgb(237 237 233 / 63%)'
                      },
                      "& td": {
                        borderRight:
                          "1px solid var(--datatable-row-background-hover-color)",
                        lineHeight: "16px",
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "var(--primary-color-800)",
                        fontFamily: "Inter",
                      },

                      "& tr": {
                        lineHeight: "16px",
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "var(--primary-color-800)",
                        fontFamily: "Inter",
                      },
                    }),
                  }}
                  muiPaginationProps={{
                    rowsPerPageOptions: [25, 50, 100, 300],
                  }}
                  // For providing color to header of table
                  muiTableHeadCellProps={{
                    sx: (theme) => ({
                      background: "var(--datatable-row-background-color)", //'#e9e9e9',
                      borderRight:
                        "1px solid var(--datatable-row-background-hover-color)",
                      lineHeight: "16px",
                      fontWeight: "500",
                      fontSize: "14px",
                      color: "var(--primary-color-800)",
                      fontFamily: "Inter",
                    }),
                  }}
                  manualFiltering
                  manualPagination
                  manualSorting
                  muiToolbarAlertBannerProps={
                    // isError
                    // ? {
                    //   color: "error",
                    //   children: "Error loading data",
                    // }
                    // : undefined
                    {
                      isError: () => ({
                        color: "error",
                        children: "Error loading data",
                      }),
                      sx: (theme) => ({
                        background: "var(--datatable-row-background-color)", //'#e9e9e9',
                        lineHeight: "16px",
                        fontWeight: "500",
                        fontSize: "14px",
                        color: "var(--primary-color-800)",
                        fontFamily: "Inter",
                      }),
                    }
                  }
                  muiSelectCheckboxProps={{
                    sx: (theme) => ({
                      lineHeight: "16px",
                      fontWeight: "400",
                      fontSize: "12px",
                      color: "var(--prinary-color-800)",
                      fontFamily: "Inter",
                    }),
                  }}
                  muiSelectAllCheckboxProps={{
                    sx: (theme) => ({
                      lineHeight: "16px",
                      fontWeight: "400",
                      fontSize: "12px",
                      color: "var(--prinary-color-800)",
                      fontFamily: "Inter",
                    }),
                  }}
                  // condit
                  onColumnFiltersChange={setColumnFilters} // for termp comment filteron column
                  onGlobalFilterChange={setGlobalFilter}
                  onPaginationChange={setPagination}
                  onSortingChange={setSorting}
                  rowCount={rowCount}
                  // enableColumnVirtualization={false}
                  // enableColumnVirtualization
                  state={{
                    // columnFilters, // for termp comment filteron column
                    // globalFilter,
                    isLoading,
                    pagination,
                    showAlertBanner: isError,
                    showProgressBars: isRefetching,
                    sorting,
                  }}
                /> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <DeleteConfirmationModal
        deleteApiUrl={`${config.salesconfigBaseUrl}/sales/batchdelete`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />
      <DeliveryStatusConfirmation
        deliveryStatusList={deliveryStatusList}
        setShowDeliverySelect={setShowDeliverySelect}
        showDeliverySelect={showDeliverySelect}
        open={deliveryModalOpen}
        onClose={handelcloseMenu}
        // closeMenuofrow={handelcloseMenu}
      />
      <LookupReceiptSaleModal />
    </>
  );
};

export default Sales;
